const walletUrl = window.ctsautoconf && window.ctsautoconf.WALLET_URL ? window.ctsautoconf.WALLET_URL : process.env.WALLET_URL
const geocomplyURL = window.ctsautoconf && window.ctsautoconf.GEOCOMPLY_URL ? window.ctsautoconf.GEOCOMPLY_URL : process.env.GEOCOMPLY_URL
const androidApp = window.ctsautoconf.APP_DOWNLOAD_ANDROID
const iosApp = window.ctsautoconf.APP_DOWNLOAD_IOS
export default {
  resetPassword: `${walletUrl}forgottenpassword`,
  registration: `${walletUrl}register`,
  geocomplyURL: geocomplyURL,
  installIosApp: iosApp,
  installAndroidApp: androidApp,
  geocomplyInstallerKey: 'gKRYPn0XUx',
  geocomplyPluginVersion: '3.1.1.3',
  geocomplyPluginURL: (process.env.NODE_ENV === 'production') ? 'ums.geocomply.com' : 'stg-ums.geocomply.net'
}



// WEBPACK FOOTER //
// ./src/config/externalUrls.js